import { useState, useEffect } from 'react';
import { Form, Input, Button, Icon, Card, Spin, Modal, Alert } from 'antd';
import { authenticateWithRedirect } from '../../../../api/api';
import { GBCRUrl } from '../../../../api/api-config';
import { withRouter } from 'react-router-dom';
import systemError from '../../../../systemError.png';
import Validator from '../../../../utils/container-validator';
import _ from 'lodash';

const AuthForm = (props) => {
  const [showEmailWarning, setShowEmailWarning] = useState(false);
  const [showEmailSpaceWarning, setShowEmailSpaceWarning] = useState(false);
  const [showBLWarning, setShowBLWarning] = useState(false);
  const [showBLSpaceWarning, setShowBLSpaceWarning] = useState(false);
  const [showProcessing, isShowProcessing] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('authFormEmail') != null) {
      props.form.setFieldsValue({
        emailAddress: localStorage.getItem('authFormEmail'),
      });
    }
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();
    props.form.validateFields(async (err, values) => {
      if (!err) {
        const emailRule = /(^\s*)[\da-z]+([\-\.\_]?[\da-z]+)*@[\da-z]+([\-\.]?[\da-z]+)*(\.[a-z]{2,})+(\s*$)/gi;
        const cntRule = /^([a-zA-Z]{4}[\s]?[0-9]{6}[\s]?[(]?[0-9]?[)]?)|([0-9]{9}(([0-9a-zA-Z]{3})|[0-9]{1}))$/gi;
        const blAndContainerSpecialRule = /^[0-9a-zA-Z]*$/gim;
        const blRule = /^([a-z]{4})?[0-9]{9}(([0-9a-zA-Z]{3})|[0-9]{1})$/gim;
        const emailValue = values.emailAddress;
        const blValue = values.bizKey;

        if (!emailRule.test(emailValue)) {
          setShowEmailWarning(true);
          return;
        }

        if (emailValue.indexOf(' ') != -1) {
          setShowEmailSpaceWarning(true);
          return;
        }

        if (blValue.indexOf(' ') != -1) {
          setShowBLSpaceWarning(true);
          return;
        }

        if (!blRule.test(blValue) && !cntRule.test(blValue)) {
          setShowBLWarning(true);
        } else {
          localStorage.setItem('AuthForm', values.emailAddress);
          // sessionStorage.setItem("email",values.email);
          const BKG_BL_REGEX = /([a-z]{4})?[0-9]{9}(([0-9a-zA-Z]{3})|[0-9]{1})/gi;
          const isBL = !!BKG_BL_REGEX.exec(values.bizKey);

          const DIGIT = 10;
          if (!isBL && blValue.length > DIGIT) {
            var validator = new Validator();
            const checkDigit = validator.createCheckDigit(blValue.substring(0, DIGIT));
            if (checkDigit.toString() != blValue.substring(DIGIT, blValue.length).toString()) {
              setShowBLWarning(true);
              return;
            }
          }
          let extractedBizKey = null;
          if (isBL && values.bizKey.length !== 10) {
            extractedBizKey = values.bizKey.substring(values.bizKey.length - 10);
          } else {
            extractedBizKey = values.bizKey;
          }

          const reqBody = {
            emailAddress: values.emailAddress,
            bizKey: extractedBizKey,
            bizKeyType: isBL ? 'BL' : 'CNTR',
          };

          isShowProcessing(true);

          authenticateWithRedirect(reqBody)
          .then(
            (resp) => {
              const errorCodes = resp.errCodes;
              const requestId = resp.requestId;
              const FND = resp.FND;
              sessionStorage.setItem('containerInfos_unchoice', JSON.stringify(resp));
              
              if (errorCodes.indexOf('ERR_NOT_AUTH') !== -1 || errorCodes.indexOf('ERR_INVALID_BIZ_KEY') !== -1) {
                props.history.push({
                  pathname: '/not-authorized',
                  data: { requestId: requestId, errCodes: errorCodes },
                });
              } else if (!(FND.includes('Ireland') || FND.includes('United Kingdom'))) {
                isShowProcessing(false);
                Modal.warning({
                  width: 550,
                  title: (
                    <div className="popTitle">
                      <div className="popTitle-line" />
                      <span>Unsupported Shipment</span>
                    </div>
                  ),
                  content: (
                    <div className="popContent">
                      <div className="center" style={{ alignItems: 'flex-start' }}>
                        <img src={systemError} style={{ width: 18, marginRight: 6 }} />
                        Sorry, system support United Kingdom and Ireland destined shipment only. Please check you have entered your shipment correctly and try again.
                      </div>
                    </div>
                  ),
                  icon: null,
                  className: 'web',
                  onOk() { },
                });
              } else if (errorCodes.indexOf('ERR_SOP_EXPIRED') !== -1) {
                isShowProcessing(false);
                Modal.warning({
                  width: 500,
                  title: (
                    <div className="popTitle">
                      <div className="popTitle-line" />
                      <span>Release to order has expired</span>
                    </div>
                  ),
                  content: (
                    <div className="popContent">
                      <div className="center" style={{ alignItems: 'flex-start' }}>
                        <img src={systemError} style={{ width: 18, marginRight: 6 }} />
                        Sorry, please check with Consignee and apply for extension. If you have any question, please contact OOCL customer service.
                      </div>
                    </div>
                  ),
                  icon: null,
                  className: 'web',
                  onOk() { },
                });
              } else if (_.isEmpty(resp.token)) {
                isShowProcessing(false);
                Modal.info({
                  title: (
                    <div className="popTitle">
                      <div className="popTitle-line" />
                      <span>System Error</span>
                    </div>
                  ),
                  content: (
                    <div className="popContent">
                      <div style={{ fontWeight: 600, color: '#333' }} className="center">
                        <img src={systemError} style={{ width: 18, marginRight: 6 }} />
                        Something went wrong. Please try again.
                      </div>
                    </div>
                  ),
                  okText: 'Try again',
                  icon: null,
                  className: 'web',
                });
              } else {
                window.location.href = GBCRUrl + resp.token;
              }
          }).catch((err) => {
            isShowProcessing(false);
            Modal.info({
              title: (
                <div className="popTitle">
                  <div className="popTitle-line" />
                  <span>System Error</span>
                </div>
              ),
              content: (
                <div className="popContent">
                  <div style={{ fontWeight: 600, color: '#333' }} className="center">
                    <img src={systemError} style={{ width: 18, marginRight: 6 }} />
                    Something went wrong. Please try again.
                  </div>
                </div>
              ),
              okText: 'Try again',
              icon: null,
              className: 'web',
            });
          });
        }
      }
    });
  };

  const handleEmailInputChange = (e) => {
    setShowEmailWarning(false);
    setShowEmailSpaceWarning(false);
  };

  const handleBlInputChange = (e) => {
    setShowBLWarning(false);
    setShowBLSpaceWarning(false);
  };

  const { getFieldDecorator } = props.form;
  sessionStorage.removeItem('containerInfos_unchoice');

  return (
    <div className="Auth_formStyle">
      {/* <h3>Dear Customer, </h3>
      <p>We are currently experiencing technical difficulties, which is slowing down our response time for requests put through the portal. </p>
      <p>If you have an urgent request, please send an email to ukimport@oocl.com </p>
      <p>Any requests already made through the portal will continue to be worked through as quickly as possible.</p>
      <p>Apologies for any inconvenience.</p> */}
      <Spin style={{ fontSize: 40 }} size="large" tip="Processing..." spinning={showProcessing}>
        <Card
          title="Enter Release Information"
          headStyle={{
            backgroundColor: '#d5f3ff',
            color: '#666',
            fontWeight: 400,
            borderBottom: 0,
          }}
          bodyStyle={{ width: '100%' }}
        >
          <Form onSubmit={handleSubmit} labelCol={{ span: 1000 }} wrapperCol={{ span: 1000 }}>
            <Form.Item label="Email">
              {getFieldDecorator('emailAddress', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your email!',
                  },
                ],
              })(<Input prefix={<Icon type="mail" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" onChange={handleEmailInputChange} />)}
            </Form.Item>
            {showEmailWarning ? <span style={{ color: 'red' }}>The input is not valid email!</span> : []}
            {showEmailSpaceWarning ? <span style={{ color: 'red' }}>Contain invalid characters or space</span> : []}
            <Form.Item label="Shipment" style={{ marginBottom: 0 }}>
              {getFieldDecorator('bizKey', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your bill of lading or container number!',
                  },
                ],
              })(<Input prefix={<Icon type="search" style={{ width: '100%' }} />} placeholder="Bill of lading or container number" onChange={handleBlInputChange} />)}
            </Form.Item>
            {showBLWarning ? <span style={{ color: 'red', fontSize: 13.5 }}>Please enter a valid bill of lading or container number!</span> : []}
            {showBLSpaceWarning ? <span style={{ color: 'red' }}>Contain invalid characters or space</span> : []}
            <Alert message="Note, if you encountered access error with container number, please try to use BL number instead. Thanks." type="warning" showIcon />
            <Form.Item>
              <div className="justInCenter" style={{ marginTop: 30 }}>
                {/* <Button type="link" onClick={handleRegister} style={{ width:'20%', marginRight:10 }} block>
                  Register
                </Button> */}
                <Button htmlType="submit" type="primary" block>
                  Search
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </div>
  );
};

const _AuthForm = Form.create()(AuthForm);
export default withRouter(_AuthForm);
